export default "__VITE_ASSET__2ec7d763__"